import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthenticationService, AuthType } from '../../../services/authentication.service';

@Component({
  selector: 'staff-login',
  templateUrl: './staff-login.component.html',
  styleUrl: './staff-login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StaffLoginComponent implements OnInit {
  constructor(private authService: AuthenticationService) {
    console.log('StaffLoginComponent created');
  }

  ngOnInit() {
    // Initialize auth for Staff with AuthType.Staff
    this.authService.init(AuthType.Staff);
  }
}
